import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import RecruitmentForm from './components/RecruitmentForm';
import Login from './components/dashboard/Login';
import DashboardLayout from './components/dashboard/DashboardLayout';
import ApplicationsList from './components/dashboard/ApplicationsList';
import ApplicationDetail from './components/dashboard/ApplicationDetail';
import Statistics from './components/dashboard/Statistics';
import Parametres from './components/dashboard/Parametres';

function App() {
  return (
    <Router>
      <ToastContainer position="bottom-right" autoClose={4000} hideProgressBar newestOnTop />
      <Routes>
        {/* Formulaire public */}
        <Route path="/" element={<RecruitmentForm />} />

        {/* Dashboard recruteur */}
        <Route path="/recruteur/login" element={<Login />} />
        <Route path="/recruteur" element={<DashboardLayout />}>
          <Route index element={<Statistics />} />
          <Route path="list" element={<ApplicationsList />} />
          <Route path="list/:id" element={<ApplicationDetail />} />
          <Route path="parametres" element={<Parametres />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
